import API from "../../api/api";
import UserReviews from "./UserReviews";
import { Link } from "react-router-dom";
import ProfileCard from "./ProfileCard";
import React, { Component } from "react";
import "../../styles/css/users/Profile.css";
import ProfileDetails from "./ProfileDetails";
import { Container, Row, Col } from "bootstrap-4-react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormStatus from "./FormStatus";

const userId = localStorage.getItem("userId");

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: this.props.match.params.id,
      isLoggedUser: false,
      isDashboardLoading: true,
      cardData: "",
      reviews: "",
      profileData: "",
    };
  }

  componentDidMount() {
    this.setState({
      isLoggedUser: this.state.userId === userId ? true : false,
    });

    API.post("user/profile/" + this.state.userId)
      .then((res) => {
        const profile = res.data.response;
        this.setState({
          cardData: profile.card,
          reviews: profile.review,
          profileData: profile.user[0],
          isDashboardLoading: false,
        });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  }

  render() {
    const { isDashboardLoading } = this.state;

    return (
      <div>
        {isDashboardLoading ? (
          <div className="preloader">
            <CircularProgress className="preloaderCircle" />
          </div>
        ) : (
          <div className="jobCreationMain">
            <Container className="breadCrubmContainerDashboard">
              <div className="breadCrumb">
                <Link to="/" className="prevLinks">
                  Dashboard
                </Link>
                <span>&nbsp;&gt;&nbsp;</span>
                <span className="currLink">Profile</span>
              </div>
            </Container>
            <div className="browseMain">
              <Container>
                <Row>
                  <Col col="sm-12 md-12 lg-3">
                    <div>
                      <ProfileCard cardData={this.state.cardData} />
                    </div>
                  </Col>
                  {this.state.isLoggedUser ? (
                    <Col col="sm-12 md-12 lg-9">
                      <div>
                        <ProfileDetails
                          isLoggedUser={this.state.isLoggedUser}
                          profileData={this.state.profileData}
                        />
                      </div>
                    </Col>
                  ) : (
                    <Col col="sm-12 md-12 lg-9">
                      <div>
                        <div className="activeUsersDiv">
                          <span>Reviews</span>
                          <ArrowDropDownIcon />
                        </div>
                        <UserReviews reviews={this.state.reviews} />
                      </div>
                    </Col>
                  )}
                </Row>
                {this.state.isLoggedUser && (
                  <div>
                    {this.state.profileData.user_roles[0].name ===
                      "Surveyor" && (
                      <Row>
                        <Col col="sm-12 md-12 lg-3"></Col>
                        <Col col="sm-12 md-12 lg-9">
                          <div className="activeUsersDiv formStatus">
                            <FormStatus
                              isLoggedUser={this.state.isLoggedUser}
                              profileData={this.state.profileData}
                            />
                          </div>
                        </Col>
                      </Row>
                    )}

                    <Row>
                      <Col col="sm-12 md-12 lg-3"></Col>
                      <Col col="sm-12 md-12 lg-9">
                        <div>
                          <div className="activeUsersDiv">
                            <span>Reviews</span>
                            <ArrowDropDownIcon />
                          </div>
                          <UserReviews reviews={this.state.reviews} />
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}
              </Container>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/pages/Users/Profile.js